import { render, staticRenderFns } from "./EditAlbumModal.vue?vue&type=template&id=ab6189c8"
import script from "./EditAlbumModal.vue?vue&type=script&lang=js"
export * from "./EditAlbumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports